// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__17tXl","resendInfoText":"OnGoingPaymentBox_resendInfoText__1BrvE"};